import * as React from 'react';
import { FC } from 'react';

import { RewardsCarouselView } from './rewards-carousel.view';
import { IRewardsCarouselProps } from './types';

/**
 * A carousel for loyalty rewards
 */
const RewardsCarousel: FC<IRewardsCarouselProps> = ({ rewards }) => {
  return <RewardsCarouselView rewards={rewards} />;
};

export default RewardsCarousel;
